<template>
    <guest-layout>
        <div class="verified-wrap" v-if="success">
            <img src="/assets/images/check.svg">
            <p>{{ successMessage }}</p>
            <button @click="success = !success" class="btn btn-primary main-button login-button">Oke</button>
            <button v-if="tag =='iklandisini'" @click="RedirectPage()" class="btn mt-10 btn-primary main-button cancel-button router-link-activ">Kembali Ke dashboard IklanDisini</button>

            <button v-if="tag =='serbada'" class="btn mt-10 btn-primary main-button cancel-button router-link-activ">Kembali Ke dashboard Serbada</button>

        </div>
        <div v-else>
            <loading-block v-if="loading" />


            <div class="wrap-login" v-else>

                <div class="set_center">
                    <h5>Satu Akun Arkadia.me</h5>
                    <h6 class="font-size">Untuk beraktivitas di semua layanan <a href="https://arkadiacorp.com/">Arkadia Corp</a></h6>
                </div>

                <h3 class="font-weight-bold text-uppercase">Register</h3>
                <form v-on:keyup.enter="handleSubmit">
                    <div class="form-group">
                        <input type="email" v-model="form.email" v-bind:class="errors.hasOwnProperty('email') ? 'is-invalid' : ''" class="form-control custom-input" placeholder="Email">
                        <div class="invalid-feedback" v-if="errors.hasOwnProperty('email')">
                            {{ errors['email'][0] }}
                        </div>
                    </div>
                    <div class="form-group">
                        <input type="text" v-model="form.username" v-bind:class="errors.hasOwnProperty('username') ? 'is-invalid' : ''" class="form-control custom-input" placeholder="Username">
                        <div class="invalid-feedback" v-if="errors.hasOwnProperty('username')">
                            {{ errors['username'][0] }}
                        </div>
                    </div>
                    <div class="form-group">
                        <input type="text" v-model="form.first_name" v-bind:class="errors.hasOwnProperty('first_name') ? 'is-invalid' : ''" class="form-control custom-input" placeholder="Nama Depan">
                        <div class="invalid-feedback" v-if="errors.hasOwnProperty('first_name')">
                            {{ errors['first_name'][0] }}
                        </div>
                    </div>
                    <div class="form-group">
                        <input type="text" v-model="form.last_name" v-bind:class="errors.hasOwnProperty('last_name') ? 'is-invalid' : ''" class="form-control custom-input" placeholder="Nama Belakang">
                        <div class="invalid-feedback" v-if="errors.hasOwnProperty('last_name')">
                            {{ errors['last_name'][0] }}
                        </div>
                    </div>
                    <div class="form-group">
                            
                            <input type="text" class="form-control custom-input" id="no_handphone" placeholder="No Handphone" v-bind:class="errors.hasOwnProperty('phone') ? 'is-invalid' : ''" v-model="form.phone">
                            <div class="invalid-feedback" v-if="errors.hasOwnProperty('phone')">
                                {{ errors['phone'][0] }}
                            </div>
                        </div>

                        <div class="form-group">
                            <select class="form-control custom-input" id="jenis_kelamin" v-bind:class="errors.hasOwnProperty('gender') ? 'is-invalid' : ''" v-model="form.gender">
                                <option value="0">Pilih Jenis Kelamin</option>
                                <option value="2">Laki - laki</option>
                                <option value="1">Perempuan</option>
                            </select>
                            <div class="invalid-feedback" v-if="errors.hasOwnProperty('gender')">
                                {{ errors['gender'][0] }}
                            </div>
                        </div>
                        <div class="form-group">
                           
                            <date-picker v-model="form.birthday" placeholder="Tanggal Lahir" id="tanggal_lahir" valueType="format" format="DD-MM-YYYY"  v-bind:class="errors.hasOwnProperty('birthday') ? 'is-invalid' : ''"></date-picker>
                            <div class="invalid-feedback" v-if="errors.hasOwnProperty('birthday')">
                                {{ errors['birthday'][0] }}
                            </div>
                        </div>
                        <div class="form-group">
                            
                            <multiselect id="interests"  placeholder="Interest" v-model="form.interests" :options="interests" track-by="name"  label="name" :multiple="true" v-bind:class="errors.hasOwnProperty('interests') ? 'is-invalid' : ''"></multiselect>
                            <div class="invalid-feedback" v-if="errors.hasOwnProperty('interests')">
                                {{ errors['interests'][0] }}
                            </div>
                        </div>

                        <div class="row">
                        <div class="form-group col-md-6">
                            
                            <select class="form-control custom-input" id="provinsi" @change="changeProvince" v-model="form.province_id" v-bind:class="errors.hasOwnProperty('province_id') ? 'is-invalid' : ''">
                                <option value="0">Provinsi</option>
                                <option v-for="item in province" :value="item.id">{{ item.name }}</option>
                            </select>
                            <div class="invalid-feedback" v-if="errors.hasOwnProperty('province_id')">
                                {{ errors['province_id'][0] }}
                            </div>
                        </div>
                        <div class="form-group col-md-6">
                    
                            <select class="form-control custom-input" id="kota" v-model="form.regency_id" :disabled="!form.province_id" v-bind:class="errors.hasOwnProperty('regency_id') ? 'is-invalid' : ''">
                                <option value="0">Kota</option>
                                <option v-for="item in regency" :value="item.id">{{ item.name }}</option>
                            </select>
                            <div class="invalid-feedback" v-if="errors.hasOwnProperty('regency_id')">
                                {{ errors['regency_id'][0] }}
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <input type="password" v-model="form.password" v-bind:class="errors.hasOwnProperty('password') ? 'is-invalid' : ''" class="form-control custom-input" placeholder="Password">
                        <div class="invalid-feedback" v-if="errors.hasOwnProperty('password')">
                            {{ errors['password'][0] }}
                        </div>
                    </div>
                    <div class="form-group">
                        <input type="password" v-model="form.password_confirmation" v-bind:class="errors.hasOwnProperty('password_confirmation') ? 'is-invalid' : ''" class="form-control custom-input" placeholder="Konfirmasi Password">
                        <div class="invalid-feedback" v-if="errors.hasOwnProperty('password_confirmation')">
                            {{ errors['password_confirmation'][0] }}
                        </div>
                    </div>


                     <div class="form-group">
                            <p>Kamu lebih pilih nulis atau ikut event nih?</p>
                            <select class="form-control custom-input" id="survei_action" v-bind:class="errors.hasOwnProperty('survei_action') ? 'is-invalid' : ''" v-model="form.survei_action">
                                <option value="0">Pilih Survei</option>
                                <option value="menulis">Menulis</option>
                                <option value="event">Event</option>
                            </select>
                            <div class="invalid-feedback" v-if="errors.hasOwnProperty('survei_action')">
                                {{ errors['survei_action'][0] }}
                            </div>
                    </div>

<!--                     <div class="form-group border-dotted pull-left padding-dotted">
                            <p>Klo kamu ingin mendapatkan salary berapakah kisarannya ?</p>
                            <div class="full pull-left">
                                    <input class="pull-left margin-input" type="radio" name="salary_range" v-model="form.salary_range" value="5000000"> 
                                    <span class="pull-left padding-label"> Kurang dari Rp 5.000.000 </span>
                             </div>
                             <div class="full pull-left">
                                    <input class="pull-left margin-input" type="radio" name="salary_range" v-model="form.salary_range" value="10000000">
                                    <span class="pull-left padding-label"> 5.000.000 - Rp 10.000.000 </span>
                             </div> 

                             <div class="full pull-left">
                                    <input class="pull-left margin-input" type="radio" name="salary_range" v-model="form.salary_range" value="15000000">
                                    <span class="pull-left padding-label"> Rp 10.000.000 - Rp 15.000.000 </span>
                             </div>

                              <div class="full pull-left">
                                    <input class="pull-left margin-input" type="radio" name="salary_range" v-model="form.salary_range" value="20000000">
                                    <span class="pull-left padding-label"> Rp 15.000.000 - Rp 20.000.000 </span>
                             </div>

                             <div class="full pull-left">
                                    <input class="pull-left margin-input" type="radio" name="salary_range" v-model="form.salary_range" value="25000000">
                                    <span class="pull-left padding-label"> Lebih dari Rp 20.000.000 </span>
                             </div>      
                        </div> -->

                </form>
                <div class="row mb-3">
                    <div class="col-12">
                        <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="approved" v-bind:class="errors.hasOwnProperty('agree') ? 'is-invalid' : ''" v-model="form.agree">
                            <label class="form-check-label" for="approved">Saya setuju dengan <router-link :to="{ name: 'terms' }" target="_blank" class="font-weight-bold text-dark">Syarat & Ketentuan</router-link></label>
                            <div class="invalid-feedback" v-if="errors.hasOwnProperty('agree')">
                                {{ errors['agree'][0] }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mb-3"> 
                    <div class="col-12"> 
                        <vue-recaptcha ref="recaptcha" sitekey="6LewCUwcAAAAAI5TXwwxnMcqc8_c2SANSbkZmNO1" :loadRecaptchaScript=true @verify="handleRecaptcha"></vue-recaptcha>
                   </div>
                </div>

                <button class="btn btn-primary main-button register-button" @click="handleSubmit">Daftar</button>
                <br>

             
            

                <router-link :to="{ path: 'login?ref=' + tag }" class="btn btn-primary main-button cancel-button">Batal</router-link>


                <div class="text-center mt-3">
                    <p>Anda sudah memiliki akun ?
                        <br>
                        
                            <router-link :to="{ path: 'popup?ref=' + tag }"  class="font-weight-bold text-dark">Klik Masuk</router-link>

                          
                    </p>
                </div>
            </div>
        </div>
    </guest-layout>
</template>
<script>
import axios from "axios";
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import VueRecaptcha from 'vue-recaptcha';
import 'vue2-datepicker/index.css';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
export default {
    components: { Multiselect,DatePicker,VueRecaptcha },
    data() {
        return {
            errors: [],
            tag:'',
            form: {
                email: '',
                username: '',
                first_name: '',
                last_name: '',
                phone: '',
                gender: 0,
                province_id: '0',
                regency_id: '0',
                birthday: '',
                interests: null,
                password: '',
                password_confirmation: '',
                redirect:'',
                survei_action:'0',
                salary_range:'',
                recaptcha: '',
                agree: false
            },
            province: [],
            regency: [],
            interests: [],
            RedirectLink:'',
            loading: false,
            success: false,
            successMessage: ''

        }
    },
    mounted(){
      const urlParams = new URLSearchParams(window.location.search);
      this.tag = urlParams.get("ref");
      this.getInterest();
      this.getProvince();
      if(this.tag !='')
      {
        if(this.tag =='google')
        {
             this.GetAuthSosmed(urlParams.get("ref"),urlParams.get("id"));
        }else{
           this.form.redirect = this.tag;  
        } 
      }  

     

    },
    methods: {
        GetAuthSosmed(type,id){
                axios.get('/api/auth/sosmed?type='+ type + '&id=' + id)
                .then((response) => {
                    
                   this.form.username = response.data.result.username.toLowerCase(); 
                   this.form.email = response.data.result.email;
                   this.form.first_name = response.data.result.first_name;
                   this.form.last_name = response.data.result.last_name;
                   this.form.avatar = response.data.result.avatar;
                    
                })
                .catch((error) => {

                });
           
        },
         handleRecaptcha(response) {
            if(response) {
                this.form.recaptcha = response
            }
        },
        async getInterest() {
            //const token = this.$cookies.get('token');
            await axios.get(`/api/interest-reg`)
                .then((response) => {
                    this.interests = response.data
                    this.loading = false
                })
                .catch((error) => {

                });
        },
        getProvince () {
            //const token = this.$cookies.get('token');
            axios.get('/api/province-reg')
                .then((response) => {
                    this.province = response.data
                    this.form.regency_id = '0';
                    this.regency = [];
                })
                .catch((error) => {

                });
        },
        changeProvince(e) {
            this.getRegency(e.target.value)
        },
        getRegency (province_id) {
            const token = this.$cookies.get('token');
            axios.get(`/api/regency-reg?province_id=${province_id}`)
                .then((response) => {
                    this.regency = response.data
                })
                .catch((error) => {

                });
        },
        async handleSubmit () {
            this.loading = true;
            this.errors = [];

             if(this.form.redirect)
            {
                this.RedirectLink = '?ref='+ this.form.redirect;
            }else{
                this.RedirectLink = '';
            }

            if( this.form["birthday"]) {
                this.form["birthday"] = moment(this.form["birthday"], "DD-MM-YYYY").format("YYYY-MM-DD");
            }

            await axios.post('/api/register' + this.RedirectLink, this.form)
                .then((response) => {
                    this.loading = false;
                    this.success = true;
                    this.successMessage = response.data.message;
                })
                .catch((error) => {
                    this.loading = false;
                    if(error.response) {
                        this.$notify({
                            duration: 5000,
                            group: 'main',
                            title: 'Oopppss!',
                            text: error.response.data.message,
                            type: 'warn'
                        })
                        if(error.response.status === 422) {
                            this.errors = error.response.data.errors
                        }
                    }
                });
        },
        RedirectPage(){
            
            if(this.tag =='iklandisini')
            {
                window.open('https://www.iklandisini.com/', '_blank'); 
            }else if(this.tag =='serbada'){
                window.open('https://www.serbada.com/', '_blank'); 
             
            } 
           
        }
    }
}
</script>
<style>

.full{
    width: 100%;
}  

.padding-dotted{
    padding: 27px 12px;
}

.border-dotted{
    border: 2px dotted #ff0000;
}
.margin-input{
    margin: 5px 0px;
}  

.padding-label{
    padding: 0px 10px;
}  

.pull-left{
   float: left; 
}   
.wrap-login {
    padding: 4%;
    margin-top: 0px!important;
}
.mt-10{
    margin: 10px 0px 0px;
}
.set_center{
  margin: 13px 0px;
  text-align: left;
  padding: 0px 0px;
}
.font-size,.font-size a{
    font-size: 14px!important;
}
#interests .multiselect__tags {
   
    border-radius: 0.4rem!important;
    border: 1px solid #e8e8e8!important;
    background: #eee!important;
    color: #495057!important;
}
.mx-datepicker {
    width: 100%!important;
   
}
.mx-input{
     background-color: #eee!important;
    border-radius: 0.4rem!important;
}

</style>
